import { HEntityOverview } from './types'
import { hsService } from './service'
import { RequestStatus, useRequest } from '@unicaiot/unica-iot-gallery-core'

export const useGetOverview = (filter?: string): RequestStatus<HEntityOverview[] | undefined> => {
    const getProsmise = () => (filter ? hsService.getOverview(filter) : undefined)

    return useRequest(getProsmise, [filter])
}
